import React from 'react';

import { useConfig, langCodes } from './ConfigHolder';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';


const LangSelection = (props) => {

  //https://cloud.google.com/text-to-speech/docs/voices
    
    const {config, updateConfig} = useConfig();
    // const [selectedOption, setSelectedOption] = useState(null);
  
    let saveLabel = props.saveLabel[0];
    
    const handleSelectChange = (event) => {
      const value = event.target.value;
      const obj = langCodes.find((obj) => obj.label === value)
      console.log(obj);
      // setSelectedOption(obj);
      if (saveLabel) {
        updateConfig(saveLabel, obj);
        // console.log('Langselection ', config)
      }
      if (props.setSelectedOption) {
        props.setSelectedOption(obj)
      }
    }

    const inputLabel  = props.label ? props.label: null;
    const getSelectInputValue = () => {
      const selectInputValue = config[saveLabel].label;
      return selectInputValue;
    }

    return ( 
      // <FormControl variant="outlined" style={{ minWidth: 120, m:4, padding:2}}>

      <FormControl variant="outlined" sx={{ mt:0.6}}>        
        <InputLabel id="language-label" sx = {{fontSize: 16}}>{inputLabel}</InputLabel>
        <Select
          labelId="language-label" // Connects the InputLabel to the Select
          label={inputLabel} // Ensures that the Select knows about the label and adjusts for it      
          value={getSelectInputValue()}
          onChange={handleSelectChange}
          sx = {{fontSize:14, maxHeight:36}}
        >
          {langCodes.map((lang) => (
            <MenuItem key={lang.value} value={lang.label}>
              {/* {lang.label} */}
             { `${lang.flag} ${lang.label}`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  };



export {LangSelection}

